import { PlayerPortalsOnSiteRegistrationAdminPanel } from './../../../common-ui/src/lib/PlayerPortals/PlayerPortalsOnSiteRegistrationAdminPanel/PlayerPortalsOnSiteRegistrationAdminPanel';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export default {
  component: () => PlayerPortalsOnSiteRegistrationAdminPanel,
  mapEntryToProps: (
    entry: PLAYER_PORTALS_MODELS.OnSiteRegistrationAdminPanel,
  ) =>
    kontentAiDataMapping.player_portals_on_site_registration_admin_panel(entry),
  depthParameter: 5,
};
